var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9998 14.4691C12.7792 14.4607 13.4413 13.9736 13.8258 13.6069C14.7681 12.7106 15.3118 11.3681 15.3118 9.98788V9.96065C15.3118 8.9146 15.0227 7.91046 14.3559 7.20803C13.8363 6.65855 13.0181 6.33693 12.5095 6.29398V6.2966C12.3785 6.29398 12.313 6.29136 12.1815 6.28717C12.1208 6.28822 12.0935 6.28717 12.0328 6.28822C12.0234 6.28822 12.0108 6.29136 11.9998 6.29136C11.9883 6.29136 11.9762 6.28822 11.9652 6.28822C11.9055 6.28717 11.8772 6.28822 11.818 6.28717C11.6865 6.29136 11.6211 6.29398 11.4885 6.2966V6.29398C10.981 6.33693 10.1638 6.65855 9.64369 7.20803C8.97688 7.91046 8.68826 8.9146 8.68826 9.96065V9.98788C8.68826 11.3681 9.23093 12.7106 10.1733 13.6069C10.5577 13.9736 11.2198 14.4607 11.9998 14.4691Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4927 15.3596L13.8348 14.884C13.3655 15.2402 12.7375 15.5634 11.9947 15.5707C11.2629 15.5634 10.637 15.2392 10.1661 14.8798L9.50555 15.3596C9.50555 15.3596 6.42922 15.7253 4.91646 18.1248C6.6356 20.1106 9.17293 21.3709 11.9994 21.3709C14.8269 21.3709 17.3627 20.1106 19.0839 18.1248C17.5675 15.7253 14.4927 15.3596 14.4927 15.3596Z",
    fill: "#4D4D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.4999C18.3513 23.4999 23.5 18.3512 23.5 11.9999C23.5 5.64805 18.3513 0.499878 12 0.499878C5.64878 0.499878 0.500046 5.64805 0.500046 11.9999C0.500046 18.3512 5.64876 23.4999 12 23.4999Z",
    stroke: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.e73e5fcd70b7262e1b925d71568b33aa.svg";
export { ForwardRef as ReactComponent };